import { defineStore } from 'pinia';
import { api } from '../client/setup.js';
import { useGlobalStore } from '../global/index.js';
import { getDefaultState } from './util.js';

export const useAviationOtcStore = defineStore('aviationOtc', {
  state: () => ({ ...getDefaultState() }),

  actions: {
    reset() {
      this.$reset();
    },
    async initSessionValidity() {
      try {
        const { data, status } = await api.get('sessionValid');
        if (data && status === 200) {
          this.validSession = data.valid;
          this.sessionData = data?.customerInfo || null;
        }
      } catch {
        this.validSession = getDefaultState().validSession;
        this.sessionData = getDefaultState().sessionData;
      }
    },
    async getLogin({ serviceTicket, serviceUrl }) {
      const endpointPath = `login/?serviceTicket=${serviceTicket}&service=${encodeURIComponent(serviceUrl)}`;
      try {
        const { data, status } = await api.get(endpointPath);
        if (data && status === 200) {
          this.validSession = true;
          this.sessionData = data;
        }
      } catch {
        this.validSession = getDefaultState().validSession;
        this.sessionData = getDefaultState().sessionData;
      }
    },
    async getLogout() {
      const globalStore = useGlobalStore();
      const apiId = 'logout';
      if (globalStore.isApiIdCallInProgress(apiId)) return;
      globalStore.incrementApiCallsInProgress(apiId);
      const endpointPath = `logout/?url=${encodeURIComponent(document.URL)}`;

      try {
        const { data: { logoutUrl } } = await api.get(endpointPath);
        this.validSession = getDefaultState().validSession;
        this.sessionData = getDefaultState().sessionData;
        this.logoutUrl = logoutUrl;
      } catch {
        this.validSession = getDefaultState().validSession;
        this.sessionData = getDefaultState().sessionData;
        this.logoutUrl = null;
      } finally {
        globalStore.decrementApiCallsInProgress(apiId);
      }
    },
    async getOtcDocuments(params) {
      try {
        const { data } = await api.get(`otcDocuments/${params.customerGuid}/${params.identifier}/en_US`);
        this.aviationDocuments = data;
      } catch {
        this.aviationDocuments = null;
      }
    },
    async getIscOtcDocuments(params) {
      try {
        const { data } = await api.get(`iscOtcDocuments/${params.identifier}/en_US`);
        this.aviationDocuments = data;
      } catch {
        this.aviationDocuments = null;
      }
    },
  },
});

export default useAviationOtcStore;
